import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { catchError, map, Observable } from 'rxjs';
import * as _ from 'lodash-es';

@Injectable({
  providedIn: 'root'
})
export class FirSysFormChartAcctMapService {

  constructor(private http: HttpClient) { }

  /**
   * Load JSON object - action codes: pfwnw7 (system acct dropdown), 4fmxwf (form data), oz9yxt (lookup)
   */
  loadJsonObject(
    baseUrl: string,
    params: Record<string, any>,
    globalService: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/loadJsonObject`;
    const merged = _.merge({}, globalService?.globalParams || globalService || {}, params);
    const urlEncoded = new URLSearchParams();
    Object.keys(merged).forEach(key => {
      if (merged[key] !== undefined && merged[key] !== null) {
        urlEncoded.set(key, typeof merged[key] === 'object' ? JSON.stringify(merged[key]) : String(merged[key]));
      }
    });
    return this.http.get<any>(`${url}?${urlEncoded.toString()}`, { withCredentials: true }).pipe(
      map(res => res),
      catchError(err => { console.error('loadJsonObject error:', err); throw err; })
    );
  }

  /**
   * Save FIR IRS Form Details
   * URL: ${baseUrl}/saveJsonObject?action_code=z98wka
   * Process: FIR_SYS_IRS_FORM_MAP_SAVE
   */
  saveFirIRSFormDetails(
    baseUrl: string,
    jsonSetting: any,
    returnObj: any[],
    globalService: any,
    filterParams: any = {}
  ): Observable<any> {
    const url = `${baseUrl}/saveJsonObject?action_code=z98wka`;

    const jsonObj = JSON.stringify(returnObj);
    const jsonSettings = JSON.stringify(jsonSetting);

    let params: any = { ...filterParams };
    if (globalService?.globalParams) {
      params = { ...globalService.globalParams, ...params };
    }

    params.jsonObj = jsonObj;
    params.jsonSettings = jsonSettings;
    params.process_name = 'FIR_SYS_IRS_FORM_MAP_SAVE';

    const urlEncoded = new URLSearchParams();
    Object.keys(params).forEach(key => {
      if (params[key] !== undefined && params[key] !== null) {
        urlEncoded.set(key, params[key].toString());
      }
    });

    const headers = new HttpHeaders({
      'Content-Type': 'application/x-www-form-urlencoded'
    });

    return this.http.post<any>(url, urlEncoded.toString(), { headers, withCredentials: true }).pipe(
      map(response => response),
      catchError(error => {
        console.error('Error in saveFirIRSFormDetails:', error);
        throw error;
      })
    );
  }
}
